/* eslint-disable consistent-return */

import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

export default defineNuxtRouteMiddleware(async (to) => {
  const fullPath = to.fullPath?.toString()

  // If /bo_merchant route, do nothing (local only)
  if (fullPath.startsWith('/bo_merchant')) return

  const { isUserAuthenticatedSeller } = useUserStore()

  // If not authenticated, do nothing
  if (!isUserAuthenticatedSeller) return

  const { onboardingCompleted } = useSellerInfoStore()

  // If path starts with "/bo-seller/onboarding"
  const isOnboardingRoute = fullPath.startsWith('/bo-seller/onboarding')

  // Seller boarded going to an onboarding route -> redirect to boarded page
  // Note: /onboarding/home is a special case, it should redirect to /bo-seller
  if (onboardingCompleted && isOnboardingRoute) {
    return navigateTo(
      fullPath.replace(/\/bo-seller\/onboarding(\/home)?/, '/bo-seller'),
    )
  }

  // Seller not boarded yet going to a boarded route -> redirect to onboarding page
  if (!onboardingCompleted && !isOnboardingRoute) {
    return navigateTo(fullPath.replace('/bo-seller', '/bo-seller/onboarding'))
  }
})
